import React, { Suspense, useState } from 'react';
import * as Sentry from '@sentry/react';
import { Route, useRouteMatch } from 'react-router-dom';
import Spinner from '@/components/Layout/Spinner';
import { Refetch } from '@/components/ui/Refetch';
import { lazyWithRetry } from '@/utils/lazy-with-retry';
import { PUBLIC_SURVEY_PATH } from './constants';

interface LoadBoundaryProps {
	children: JSX.Element;
}

const HseSurvey = lazyWithRetry(() => import('@/pages/HseSurvey'));
const Application = lazyWithRetry(() => import('./ApplicationRoutes'));
const LOAD_FAILURE_MESSAGE = 'Failed to load information';

function reloadPage(): void {
	window.location.reload();
}

function LoadBoundary({ children }: Readonly<LoadBoundaryProps>): JSX.Element {
	const fallback = <Refetch message={LOAD_FAILURE_MESSAGE} onClick={reloadPage} />;
	return (
		<Sentry.ErrorBoundary fallback={fallback}>
			<Suspense fallback={<Spinner />}>{children}</Suspense>
		</Sentry.ErrorBoundary>
	);
}

export default function Routes(): JSX.Element {
	const isPublicSurvey = !!useRouteMatch({ path: PUBLIC_SURVEY_PATH, exact: true });
	const [hasPrivateApplication, setHasPrivateApplication] = useState<boolean>(!isPublicSurvey);
	if (!isPublicSurvey && !hasPrivateApplication) {
		setHasPrivateApplication(true);
	}
	return (
		<>
			<Route exact path={PUBLIC_SURVEY_PATH}>
				<LoadBoundary>
					<HseSurvey />
				</LoadBoundary>
			</Route>
			{!!hasPrivateApplication && (
				<LoadBoundary>
					<Application />
				</LoadBoundary>
			)}
		</>
	);
}
